import React, { useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';

import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import NavBar from './componance/NavBar';
import Footer from './componance/Footer';
import PropertyListFav from './Propertylist/PropertyListFav';
import PropertyListHorizontal from './Propertylist/PropertyListHorizontal';
import SearchForm from './componance/Search/SearchForm';
import LoginModal from './componance/Login/LoginModal';
import PropertyImagesModal from './componance/Modal/PropertyImagesModal';
import DetailModalProperty from './componance/Modal/DetailModalProperty';
import DetailModalPropertyhead from './componance/Modal/DetailModalPropertyhead';
import EstimatedYield from './componance/Modal/EstimatedYield';
import ContactPopupWithArrow from './componance/ContactPopupWithArrow';
import i18n from './i18n';
import DetailModalHeader from './componance/Modal/DetailModalHeader';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SearchPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // States
  const [userId, setUserId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [selectedType, setSelectedType] = useState('all');

  const [selectedLocations, setSelectedLocations] = useState([]);
  const [favoriteProperties, setFavoriteProperties] = useState([]);
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'THB');
  const [showLoginPopup, setShowLoginPopup] = useState(false);
 
  const [bedroomFilter, setBedroomFilter] = useState(null);
 const [propertyStatus, setPropertyStatus] = useState('all');

 const [searchResults, ] = useState([]);
  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  // Drawer Favorite
  const [showFavDrawer, setShowFavDrawer] = useState(false);

  // Responsive layout
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Decode JWT
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.userId || decoded.user_id);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  // Fetch properties
  useEffect(() => {
    fetch('https://summerhousagentlive.onrender.com/api/properties')
      .then(res => res.json())
      .then(data => {
        const propsArray = Array.isArray(data) ? data : [];
        setProperties(propsArray);
        setFilteredProperties(propsArray);
      })
      .catch(err => console.error(err));
  }, []);

  // Fetch favorites
  useEffect(() => {
    if (!userId) return;
    fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}`)
      .then(res => res.json())
      .then(data => setFavoriteProperties(data))
      .catch(err => console.error(err));
  }, [userId]);

  // Handle modal open/close
  const openModal = useCallback((property) => {
    setSelectedProperty(property);
    setIsModalOpen(true);
    setSearchParams({ property: property.property_id });
  }, [setSearchParams]);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProperty(null);
    setSearchParams({});
  };

  // Open modal from URL
  useEffect(() => {
    const propId = searchParams.get('property');
    if (propId) {
      const prop = properties.find(p => p.property_id === Number(propId));
      if (prop) openModal(prop);
    }
  }, [searchParams, properties, openModal]);

  // Prevent scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = isModalOpen ? 'hidden' : 'auto';
  }, [isModalOpen]);

  



  // Toggle favorite
  const toggleFavorite = (property) => {
    if (!userId) { setShowLoginPopup(true); return; }

    const isFav = favoriteProperties.some(fav => fav.property_id === property.property_id);

    if (isFav) {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}/${property.property_id}`, { method: 'DELETE' })
        .then(() => setFavoriteProperties(prev => prev.filter(fav => fav.property_id !== property.property_id)));
    } else {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, property_id: property.property_id })
      }).then(() => setFavoriteProperties(prev => [...prev, property]));
    }
  };

  return (
    <div style={styles.container}>
      <NavBar currency={currency} setCurrency={setCurrency} />

      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '20px',
        alignItems: isMobile ? 'stretch' : 'flex-start',
        width: '100%',
      
      }}>
        {/* Left Search */}
        <div style={{ flex: 1,padding:20 }}>
          <h1 style={styles.header}>{t('feature_search')}</h1>
          <SearchForm
               properties={properties} // ต้องมี array ของ property แต่ละตัว {name, price, location, type, status, bedrooms}
              selectedLocations={selectedLocations}
              setSelectedLocations={setSelectedLocations}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              status={propertyStatus}
              setStatus={setPropertyStatus}
              bedroomFilter={bedroomFilter}
              setBedroomFilter={setBedroomFilter}
              setFilteredProperties={setFilteredProperties} // ต้องมี function สำหรับรับ filtered list
          />
        </div>

        {/* Right Properties */}
        <div style={{ flex: 4 ,padding:20}}>
           <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              {t('property.total', { count: filteredProperties.length })}
            </p>
             <div id="searchResults">
          <PropertyListHorizontal
            properties={[...filteredProperties].sort((a,b) => b.property_id - a.property_id)}
            openModal={openModal}
            currency={currency}
             results={searchResults}
          />
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && selectedProperty && (
        <div>
          <div style={styles.modalBackdrop} onClick={closeModal} />
          <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
            {/* Header */}
             <DetailModalHeader
                            closeModal={closeModal}
                            selectedProperty={selectedProperty}
                            t={t}
                            i18n={i18n}
                          />

        

            <DetailModalPropertyhead
              closeModal={closeModal}
              selectedProperty={selectedProperty}
              t={t}
              i18n={i18n}
            />

            {selectedProperty.images?.length > 0 && (
              <div style={styles.imageSlider}>
                <PropertyImagesModal images={selectedProperty.images} propertyName={selectedProperty.name} />
              </div>
            )}

            <DetailModalProperty selectedProperty={selectedProperty} onClose={closeModal} currency={currency} />
            <EstimatedYield selectedProperty={selectedProperty} />

            <button onClick={closeModal} style={styles.closeButton}>{t("close")}</button>
          </div>
        </div>
      )}

      {/* Drawer Favorites */}
      <div style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: showFavDrawer ? 0 : "-100%",
        height: "60vh",
        backgroundColor: "#fff",
        boxShadow: "0 -4px 12px rgba(191, 173, 173, 0.2)",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
        transition: "bottom 0.4s ease-in-out",
        zIndex: 1100,
        overflowY: "auto",
        padding: "20px"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2>{t("favorite_property")}</h2>
          <button onClick={() => setShowFavDrawer(false)}>✕</button>
        </div>
        <PropertyListFav 
          favorites={favoriteProperties.slice(0, 4)}
          openModal={openModal}
          toggleFavorite={toggleFavorite}
          currency={currency}
        />
      </div>

      <button onClick={() => setShowFavDrawer(true)} style={styles.favButton}>❤️</button>

      <Footer />
      {showLoginPopup && <LoginModal onClose={() => setShowLoginPopup(false)} />}
      <ContactPopupWithArrow />
    </div>
  );
}

const styles = {
  container: { display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
  },
  header: {
    fontSize: 36,
    fontWeight: 'bold',
    marginBottom: 20,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    textShadow: '1px 1px 4px rgba(0,0,0,0.15)',
    fontFamily: "'Roboto Condensed', 'Kanit', sans-serif",
    borderBottom: '3px solid #dd9e2aff',
    paddingBottom: 8,
    
  },
  modalBackdrop: {
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1000
  },
  modalContent: {
    backgroundColor: '#fff', borderRadius: 16, padding: 24, width: '95%', maxWidth: 700, maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 8px 25px rgba(0,0,0,0.2)', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1100
  },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  postedDate: { marginTop: 10, color: '#777', fontSize: '0.9rem', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: 4 },
  imageSlider: { width: '100%', maxWidth: 650, height: 400, margin: '0 auto 20px auto', overflow: 'hidden', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' },
  closeButton: { marginTop: 20, backgroundColor: '#1a2e35', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, display: 'block', marginLeft: 'auto', marginRight: 'auto' },
  favButton: {
    position: "fixed", bottom: 20, left: 20, backgroundColor: "rgba(30, 62, 93, 0.8)",
    color: "#fff", padding: 15, borderRadius: "50%", border: "none", cursor: "pointer", zIndex: 1200
  }
};

export default SearchPage;
